import {Box, Chip, Divider, FormControl, FormLabel} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {
  initialFormValidations,
  normalizeCurrencyToNumber,
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {MANDATORY_QUES} from "../../../constants/constants";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {motion} from "framer-motion";
import {
  amountSchemaWithoutRequired,
  amountSchemaWithRequired,
  optionalAmountSchema,
} from "../../../constants/validationSchemas";
import GlobalCheckBox from "../../global-fields/GlobalCheckBox";

const BusinessTypeMenuItems = [
  {name: "Lab", value: "Lab"},
  {name: "Retail", value: "Retail"},
  {name: "Wholesale", value: "Wholesale"},
  {name: "Auction House", value: "Auction House"},
];

const StepEightForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep8Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const propertyOutsideLimit = 4;
  const entrustmentsLimit = 4;
  const selectRefs = useRef({});
  const [disableDraft, setDisableDraft] = useState(false);
  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    // let data = { ...e, user_id: user?.id, proposal_id, step: proposalStep };

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      property_in_dealer_custody: normalizeCurrencyToNumber(
        e.property_in_dealer_custody
      ),
      brokers: normalizeCurrencyToNumber(e.brokers),
      contractors: normalizeCurrencyToNumber(e.contractors),
      firms: normalizeCurrencyToNumber(e.firms),
      entrustment_limit: normalizeCurrencyToNumber(e.entrustment_limit),
      entrustment_exposure: normalizeCurrencyToNumber(e.entrustment_exposure),
      entrustments_increase_clause: e.entrustments_increase_clause?.map(
        (item) => ({
          ...item,
          business_limit: normalizeCurrencyToNumber(item.business_limit),
        })
      ),
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };
  const propStep8DataMemoize = useMemo(() => propStep8Data, [propStep8Data]);

  const initialValues = {
    step: 8,
    property_in_dealer_custody:
      propStep8DataMemoize?.property_in_dealer_custody == "0" ||
      propStep8DataMemoize?.property_in_dealer_custody == 0 ||
      propStep8DataMemoize?.property_in_dealer_custody
        ? USD_FORMATTER.format(propStep8DataMemoize?.property_in_dealer_custody)
        : "",
    // property_outside:
    //   propStep8DataMemoize?.property_outside?.length > 0
    //     ? propStep8DataMemoize?.property_outside
    //     : [
    //         {
    //           name: "",
    //           pdh: "",
    //           street: "",
    //           apartment: "",
    //           city: "",
    //           state: "",
    //           zip: "",
    //         },
    //       ],
    brokers:
      propStep8DataMemoize?.brokers == 0 ||
      propStep8DataMemoize?.brokers == "0" ||
      propStep8DataMemoize?.brokers
        ? USD_FORMATTER.format(propStep8DataMemoize?.brokers)
        : "",
    contractors:
      propStep8DataMemoize?.contractors == 0 ||
      propStep8DataMemoize?.contractors == "0" ||
      propStep8DataMemoize?.contractors
        ? USD_FORMATTER.format(propStep8DataMemoize?.contractors)
        : "",
    firms:
      propStep8DataMemoize?.firms == 0 ||
      propStep8DataMemoize?.firms == "0" ||
      propStep8DataMemoize?.firms
        ? USD_FORMATTER.format(propStep8DataMemoize?.firms)
        : "",
    // total_average:
    //   propStep8DataMemoize?.total_average == 0 ||
    //     propStep8DataMemoize?.total_average == "0" ||
    //     propStep8DataMemoize?.total_average
    //     ? USD_FORMATTER.format(propStep8DataMemoize?.total_average)
    //     : null,
    entrustment_limit:
      propStep8DataMemoize?.entrustment_limit == 0 ||
      propStep8DataMemoize?.entrustment_limit == "0" ||
      propStep8DataMemoize?.entrustment_limit
        ? USD_FORMATTER.format(propStep8DataMemoize?.entrustment_limit)
        : "",
    entrustment_exposure:
      propStep8DataMemoize?.entrustment_exposure == 0 ||
      propStep8DataMemoize?.entrustment_exposure == "0" ||
      propStep8DataMemoize?.entrustment_exposure
        ? USD_FORMATTER.format(propStep8DataMemoize?.entrustment_exposure)
        : "",
    entrustments_increase_clause:
      propStep8DataMemoize?.entrustments_increase_clause?.length > 0
        ? propStep8DataMemoize.entrustments_increase_clause.map((item) => ({
            ...item,
            business_limit:
              item.business_limit == 0 ||
              item.business_limit == "0" ||
              item.business_limit
                ? USD_FORMATTER.format(item.business_limit)
                : "",
            subrogation_waiver:
              item?.subrogation_waiver === "1" || item?.subrogation_waiver === 1
                ? 1
                : 0,
          }))
        : [
            {
              business_type: "",
              business_name: "",
              business_limit: "",
              subrogation_waiver: 0,
            },
          ],
  };

  // useEffect(() => {
  //   if (propStep8DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep8DataMemoize]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      property_in_dealer_custody: optionalAmountSchema,
      // property_outside: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string().nullable(),
      //     pdh: Yup.string().nullable(),
      //     street: Yup.string()
      //       .nullable()
      //       .max(100, "Street can't exceed 100 characters"),
      //     apartment: Yup.string()
      //       .nullable()
      //       .max(100, "Apartment can't exceed 100 characters"),
      //     city: Yup.string()
      //       .nullable()
      //       .matches(
      //         /^[A-Za-z\s]+$/,
      //         "Enter a valid state name (Alphabets only)."
      //       ),
      //     state: Yup.string()
      //       .nullable()
      //       .matches(
      //         /^[A-Za-z\s]+$/,
      //         "Enter a valid state name (Alphabets only)."
      //       ),
      //     zip: Yup.string()
      //       .nullable()
      //       .matches(
      //         /^\d{5}(-\d{4})?$/,
      //         "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
      //       ),
      //   })
      // ),
      brokers: amountSchemaWithoutRequired,
      contractors: amountSchemaWithoutRequired,
      firms: amountSchemaWithoutRequired,
      total_average: amountSchemaWithoutRequired,
      entrustment_limit: amountSchemaWithoutRequired,
      entrustment_exposure: amountSchemaWithoutRequired,
      entrustments_increase_clause: Yup.array().of(
        Yup.object().shape({
          business_type: Yup.string().nullable(),
          business_name: Yup.string().nullable(),
          business_limit: amountSchemaWithoutRequired,
          subrogation_waiver: Yup.string().nullable(),
        })
      ),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 8:", values);
      handleStepData(values);
    },
  });
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 8) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };
  const handlePlusPropertyOutside = useCallback(() => {
    const lastproperty_outside =
      formik.values.property_outside[formik.values.property_outside.length - 1];

    if (
      !lastproperty_outside.name ||
      !lastproperty_outside.pdh ||
      !lastproperty_outside.street ||
      !lastproperty_outside.apartment ||
      !lastproperty_outside.city ||
      !lastproperty_outside.state ||
      !lastproperty_outside.zip
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (formik.values.property_outside.length >= propertyOutsideLimit) return;

    formik.setFieldValue("property_outside", [
      ...formik.values.property_outside,
      {
        name: "",
        pdh: "",
        street: "",
        apartment: "",
        city: "",
        state: "",
        zip: "",
      },
    ]);
  }, [formik.values.property_outside]);
  const handleMinusPropertyOutside = useCallback(
    (index) => {
      if (formik.values.property_outside.length === 1) return;

      const newproperty_outside = [...formik.values.property_outside];
      newproperty_outside.splice(index, 1);
      formik.setFieldValue("property_outside", newproperty_outside);
    },
    [formik.values.property_outside]
  );
  const handlePlusEntrustment = useCallback(() => {
    const lastentrustments_increase_clause =
      formik.values.entrustments_increase_clause[
        formik.values.entrustments_increase_clause.length - 1
      ];

    if (
      !lastentrustments_increase_clause.business_type ||
      !lastentrustments_increase_clause.business_name ||
      !lastentrustments_increase_clause.business_limit
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (formik.values.entrustments_increase_clause.length >= entrustmentsLimit)
      return;

    formik.setFieldValue("entrustments_increase_clause", [
      ...formik.values.entrustments_increase_clause,
      {
        business_type: "",
        business_name: "",
        business_limit: "",
        subrogation_waiver: 0,
      },
    ]);
  }, [formik.values.entrustments_increase_clause]);
  const handleMinusEntrustment = useCallback(
    (index) => {
      if (formik.values.entrustments_increase_clause.length === 1) return;

      const newentrustments_increase_clause = [
        ...formik.values.entrustments_increase_clause,
      ];
      newentrustments_increase_clause.splice(index, 1);
      formik.setFieldValue(
        "entrustments_increase_clause",
        newentrustments_increase_clause
      );
    },
    [formik.values.entrustments_increase_clause]
  );

  const handleAmountFieldChangeOLD = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };

  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  // console.log("formik", formik.errors);
  // console.log("formik", formik.dirty, formik.values, formik.errors);
  // console.log("propStep5DataMemoize", propStep5DataMemoize);
  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Memorandum & Entrustments</h2>
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={handleCustomSubmit}
            >
              <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                  <h2 className={style.formTitleh2}>
                    17) What limits do you desire for section 2 of the policy?
                  </h2>
                </Grid>

                <Grid size={{xs: 12, md: 12}}>
                  <h3 className={style.htitleText}>
                    Property in the Custody of Dealers including Brokers *
                  </h3>
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`property_in_dealer_custody`}
                    id={`_property_in_dealer_custody`}
                    value={formik.values?.property_in_dealer_custody}
                    onChange={(e) =>
                      handleAmountFieldChange(e, "property_in_dealer_custody")
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.property_in_dealer_custody &&
                      Boolean(formik.errors?.property_in_dealer_custody)
                    }
                    helperText={
                      formik.touched?.property_in_dealer_custody &&
                      formik.errors?.property_in_dealer_custody
                    }
                  />
                </Grid>
              </Grid>

              {/* <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, sm: 10, xl: 8}}>
                  <h2 className={style.formTitleh2}>
                    19) Property Outside of our Premises as set forth in
                    question
                  </h2>
                  <Box sx={{mt: 1}}>
                    <p className={style.htitleText + " " + style.noteText}>
                      <u>Note</u> : All carrying of goods outside of Proposer’s
                      premises must be reported in this section.
                    </p>
                  </Box>

                  <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                    <h3 className={style.htitleText}>
                      Names and Addresses of those who may have property in
                      excess of $5,000 in their custody outside the premises:
                    </h3>
                  </Grid>
                </Grid>

                {formik.values.property_outside.map((ppt, index) => {
                  return (
                    <>
                      <Grid
                        container
                        spacing={2}
                        sx={{mt: 0}}
                        key={`${index}-${index}`}
                      >
                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          {index !== 0 && (
                            <Box sx={{width: "100%", mt: 1, mb: 1}}>
                              <Divider>
                                <Chip
                                  label={`${index + 1}`}
                                  size="medium"
                                  onDelete={() =>
                                    handleMinusPropertyOutside(index)
                                  }
                                />
                              </Divider>
                            </Box>
                          )}

                          <div style={{width: "100%"}}>
                            <Box sx={{color: "#000", mb: 1}}>
                              <div className={style.plusIconMain}>
                                <FormLabel
                                  className={style.labelText}
                                  sx={{mb: 1}}
                                >
                                  Name
                                </FormLabel>

                                <div className={style.plusImgMain}>

                                  {index === 0 && (
                                    <p
                                      style={{
                                        position: "inherit",
                                        display: "flex",
                                      }}
                                      onClick={handlePlusPropertyOutside}
                                    >
                                      <img
                                        src={plusIcon}
                                        alt="add"
                                        style={{marginRight: "5px"}}
                                      />
                                      Add
                                    </p>
                                  )}
                                </div>
                              </div>
                            </Box>
                            <GlobalTextField
                              id={`property_outside.${index}.name`}
                              name={`property_outside.${index}.name`}
                              value={
                                formik.values.property_outside?.[index]?.name
                              }
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched?.property_outside?.[index]
                                  ?.name &&
                                Boolean(
                                  formik.errors?.property_outside?.[index]?.name
                                )
                              }
                              helperText={
                                formik.touched?.property_outside?.[index]
                                  ?.name &&
                                formik.errors?.property_outside?.[index]?.name
                              }
                            />
                        
                          </div>
                        </Grid>

                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}> PDH </FormLabel>
                          </FormControl>
                          <GlobalTextField
                            id={`property_outside.${index}.pdh`}
                            name={`property_outside.${index}.pdh`}
                            value={
                              formik.values?.property_outside?.[index]?.pdh
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.property_outside?.[index]?.pdh &&
                              Boolean(
                                formik.errors?.property_outside?.[index]?.pdh
                              )
                            }
                            helperText={
                              formik.touched?.property_outside?.[index]?.pdh &&
                              formik.errors?.property_outside?.[index]?.pdh
                            }
                          />
                        </Grid>
                        <Grid size={{xs: 12, lg: 10, xl: 8}}>
                          <Grid container spacing={2} sx={{mt: 1}}>
                            <Grid size={{xs: 12, md: 6}}>
                              <div style={{width: "100%"}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}>
                                    Street Name
                                  </FormLabel>
                                </FormControl>

                                <GlobalTextField
                                  id={`property_outside.${index}.street`}
                                  name={`property_outside.${index}.street`}
                                  value={
                                    formik.values?.property_outside?.[index]
                                      ?.street
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.property_outside?.[index]
                                      ?.street &&
                                    Boolean(
                                      formik.errors?.property_outside?.[index]
                                        ?.street
                                    )
                                  }
                                  helperText={
                                    formik.touched?.property_outside?.[index]
                                      ?.street &&
                                    formik.errors?.property_outside?.[index]
                                      ?.street
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid size={{xs: 12, md: 6, sm: 6}}>
                              <div style={{width: "100%"}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}>
                                    Apartment/Suite/Floor
                                  </FormLabel>
                                </FormControl>
                                <GlobalTextField
                                  id={`property_outside.${index}.apartment`}
                                  name={`property_outside.${index}.apartment`}
                                  value={
                                    formik.values?.property_outside?.[index]
                                      ?.apartment
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.property_outside?.[index]
                                      ?.apartment &&
                                    Boolean(
                                      formik.errors?.property_outside?.[index]
                                        ?.apartment
                                    )
                                  }
                                  helperText={
                                    formik.touched?.property_outside?.[index]
                                      ?.apartment &&
                                    formik.errors?.property_outside?.[index]
                                      ?.apartment
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid size={{xs: 12, md: 4, sm: 6}}>
                              <div style={{width: "100%"}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}> State </FormLabel>
                                </FormControl>
                                <GlobalTextField
                                  id={`property_outside.${index}.state`}
                                  name={`property_outside.${index}.state`}
                                  value={
                                    formik.values?.property_outside?.[index]
                                      ?.state
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.property_outside?.[index]
                                      ?.state &&
                                    Boolean(
                                      formik.errors?.property_outside?.[index]
                                        ?.state
                                    )
                                  }
                                  helperText={
                                    formik.touched?.property_outside?.[index]
                                      ?.state &&
                                    formik.errors?.property_outside?.[index]
                                      ?.state
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid size={{xs: 12, md: 4, sm: 6}}>
                              <div style={{width: "100%"}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}> City </FormLabel>
                                </FormControl>
                                <GlobalTextField
                                  id={`property_outside.${index}.city`}
                                  name={`property_outside.${index}.city`}
                                  value={
                                    formik.values?.property_outside?.[index]
                                      ?.city
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.property_outside?.[index]
                                      ?.city &&
                                    Boolean(
                                      formik.errors?.property_outside?.[index]
                                        ?.city
                                    )
                                  }
                                  helperText={
                                    formik.touched?.property_outside?.[index]
                                      ?.city &&
                                    formik.errors?.property_outside?.[index]
                                      ?.city
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid size={{xs: 12, md: 4, sm: 6}}>
                              <div style={{width: "100%"}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}> Zip Code</FormLabel>
                                </FormControl>
                                <GlobalTextField
                                  id={`property_outside.${index}.zip`}
                                  name={`property_outside.${index}.zip`}
                                  value={
                                    formik.values?.property_outside?.[index]
                                      ?.zip
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.property_outside?.[index]
                                      ?.zip &&
                                    Boolean(
                                      formik.errors?.property_outside?.[index]
                                        ?.zip
                                    )
                                  }
                                  helperText={
                                    formik.touched?.property_outside?.[index]
                                      ?.zip &&
                                    formik.errors?.property_outside?.[index]
                                      ?.zip
                                  }
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  );
                })}
              </Grid> */}

              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, xl: 8, sm: 10}}>
                  <h3 className={style.htitleText}>
                    Average daily amount in custody of others, except for those
                    in the above question (property in the custody of dealers
                    including brokers)
                  </h3>
                </Grid>
                {/* <Grid size={{xs: 12, md: 3}}>
                  <FormControl fullWidth>
                    <FormLabel sx={{mb: 1}}> Total Average </FormLabel>
                  </FormControl>
                  <GlobalTextField
                    placeH="$"
                    type="text"
                    name={`total_average`}
                    id={`_total_average`}
                    value={formik.values?.total_average}
                    error={
                      formik.touched?.total_average &&
                      Boolean(formik.errors?.total_average)
                    }
                    helperText={
                      formik.touched?.total_average &&
                      formik.errors?.total_average
                    }
                    disabled
                  />
                </Grid> */}
                <Grid size={{xs: 12, lg: 12, xl: 9}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 4}}>
                      <FormControl fullWidth>
                        <FormLabel sx={{mb: 1}}> Brokers </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`brokers`}
                        id={`_brokers`}
                        value={formik.values?.brokers}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalAvg(
                        //     "brokers",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) => handleAmountFieldChange(e, "brokers")}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.brokers &&
                          Boolean(formik.errors?.brokers)
                        }
                        helperText={
                          formik.touched?.brokers && formik.errors?.brokers
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 4}}>
                      <FormControl fullWidth>
                        <FormLabel sx={{mb: 1}}> Contractors </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`contractors`}
                        id={`_contractors`}
                        value={formik.values?.contractors}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalAvg(
                        //     "contractors",
                        //     e.target.value
                        //   )
                        // }
                        onChange={(e) =>
                          handleAmountFieldChange(e, "contractors")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.contractors &&
                          Boolean(formik.errors?.contractors)
                        }
                        helperText={
                          formik.touched?.contractors &&
                          formik.errors?.contractors
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 4}}>
                      <FormControl fullWidth>
                        <FormLabel sx={{mb: 1}}> Firms </FormLabel>
                      </FormControl>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`firms`}
                        id={`_firms`}
                        value={formik.values?.firms}
                        // onChange={(e) =>
                        //   handleChangeAndUpdateTotalAvg("firms", e.target.value)
                        // }
                        onChange={(e) => handleAmountFieldChange(e, "firms")}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.firms && Boolean(formik.errors?.firms)
                        }
                        helperText={
                          formik.touched?.firms && formik.errors?.firms
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12}}>
                  <h2 className={style.formTitleh2}>
                    18) Entrustment Increase Clause
                  </h2>
                </Grid>

                <Grid size={{xs: 12, lg: 12, xl: 9}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 6}}>
                      <Box sx={{mb: 1}}>
                        <h3 className={style.htitleText}>Entrustment Limit</h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`entrustment_limit`}
                        id={`_entrustment_limit`}
                        value={formik.values?.entrustment_limit}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "entrustment_limit")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.entrustment_limit &&
                          Boolean(formik.errors?.entrustment_limit)
                        }
                        helperText={
                          formik.touched?.entrustment_limit &&
                          formik.errors?.entrustment_limit
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                      <Box sx={{mb: 1}}>
                        <h3 className={style.htitleText}>
                          Entrustment Exposure
                        </h3>
                      </Box>
                      <GlobalTextField
                        placeH="$"
                        type="text"
                        name={`entrustment_exposure`}
                        id={`_entrustment_exposure`}
                        value={formik.values?.entrustment_exposure}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "entrustment_exposure")
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.entrustment_exposure &&
                          Boolean(formik.errors?.entrustment_exposure)
                        }
                        helperText={
                          formik.touched?.entrustment_exposure &&
                          formik.errors?.entrustment_exposure
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={{xs: 12, lg: 12, xl: 9}}>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}}>
                      <div className={style.plusIconMain}>
                        <Box sx={{mt: 1}}>
                          <h3 className={style.htitleText}>
                            Entrustment Increase Clause
                          </h3>
                        </Box>
                        <div className={style.plusImgMain}>
                          {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                          {formik.values.entrustments_increase_clause.length <
                            entrustmentsLimit && (
                            <p
                              style={{
                                position: "inherit",
                                display: "flex",
                              }}
                              onClick={handlePlusEntrustment}
                            >
                              <img
                                src={plusIcon}
                                alt="Add"
                                style={{marginRight: "5px"}}
                              />
                              Add
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    {formik.values.entrustments_increase_clause.map(
                      (ent, index) => {
                        return (
                          <>
                            {index !== 0 && (
                              <Box sx={{width: "100%", mt: 1, mb: 1}}>
                                <Divider sx={{position: "relative"}}>
                                  <Chip
                                    label={` ${index + 1}`}
                                    size="medium"
                                    clickable
                                    onDelete={() =>
                                      handleMinusEntrustment(index)
                                    }
                                  />
                                </Divider>
                              </Box>
                            )}
                            <Grid size={{xs: 12, md: 3}}>
                              <FormControl fullWidth>
                                <FormLabel sx={{mb: 1}}>
                                  Type of Business
                                </FormLabel>
                              </FormControl>
                              <GlobalSelectField
                                ref={(el) => (selectRefs.current[index] = el)}
                                name={`entrustments_increase_clause[${index}].business_type`}
                                labelId={`entrustments_increase_clause_${index}_business_type`}
                                value={
                                  formik.values?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_type || ""
                                }
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    `entrustments_increase_clause.[${index}].business_type`,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_type &&
                                  Boolean(
                                    formik.errors
                                      ?.entrustments_increase_clause?.[index]
                                      ?.business_type
                                  )
                                }
                                helperText={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_type &&
                                  formik.errors?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_type
                                }
                                menuItems={BusinessTypeMenuItems}
                                placeH={
                                  !formik.values
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_type
                                    ? "Select"
                                    : ""
                                }
                              />
                            </Grid>

                            <Grid size={{xs: 12, md: 3}}>
                              <FormControl fullWidth>
                                <FormLabel sx={{mb: 1}}>
                                  Name of Business
                                </FormLabel>
                              </FormControl>
                              <GlobalTextField
                                id={`entrustments_increase_clause.${index}.business_name`}
                                name={`entrustments_increase_clause.${index}.business_name`}
                                value={
                                  formik.values?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_name
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_name &&
                                  Boolean(
                                    formik.errors
                                      ?.entrustments_increase_clause?.[index]
                                      ?.business_name
                                  )
                                }
                                helperText={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_name &&
                                  formik.errors?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_name
                                }
                              />
                            </Grid>

                            <Grid size={{xs: 12, md: 3}}>
                              {/* <div className={style.plusIconMain}> */}
                              {/* <div style={{ width: "100%" }}> */}
                              <FormControl fullWidth>
                                <FormLabel sx={{mb: 1}}> Limit </FormLabel>
                              </FormControl>

                              <GlobalTextField
                                placeH="$"
                                type="text"
                                id={`entrustments_increase_clause.${index}.business_limit`}
                                name={`entrustments_increase_clause.${index}.business_limit`}
                                value={
                                  formik.values?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_limit
                                }
                                onChange={(e) =>
                                  handleAmountFieldChange(
                                    e,
                                    `entrustments_increase_clause.[${index}].business_limit`
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_limit &&
                                  Boolean(
                                    formik.errors
                                      ?.entrustments_increase_clause?.[index]
                                      ?.business_limit
                                  )
                                }
                                helperText={
                                  formik.touched
                                    ?.entrustments_increase_clause?.[index]
                                    ?.business_limit &&
                                  formik.errors?.entrustments_increase_clause?.[
                                    index
                                  ]?.business_limit
                                }
                              />
                              {/* </div> */}
                              {/* <div className={style.plusImgMain}>
                                  {formik.values.entrustments_increase_clause
                                    .length > 1 && (
                                      <p
                                        onClick={() =>
                                          handleMinusEntrustment(index)
                                        }
                                      >
                                        <img src={minusIcon} alt="minus" />
                                      </p>
                                    )}
                                  {index ===
                                    formik.values.entrustments_increase_clause
                                      .length -
                                    1 && (
                                      <p onClick={handlePlusEntrustment}>
                                        <img src={plusIcon} alt="add" />
                                      </p>
                                    )}
                                </div> */}
                              {/* </div> */}
                            </Grid>

                            <Grid size={{xs: 12, md: 3}}>
                              <FormControl fullWidth>
                                <FormLabel sx={{mb: 1}}>
                                  Waiver of Subrogation
                                </FormLabel>
                              </FormControl>
                              <GlobalCheckBox
                                title="Yes"
                                selected={
                                  formik.values?.entrustments_increase_clause?.[
                                    index
                                  ]?.subrogation_waiver == 1
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  formik.setFieldValue(
                                    `entrustments_increase_clause.[${index}].subrogation_waiver`,
                                    formik.values
                                      ?.entrustments_increase_clause?.[index]
                                      ?.subrogation_waiver == 1
                                      ? 0
                                      : 1
                                  );
                                }}
                                error={
                                  formik.touched.subrogation_waiver &&
                                  Boolean(formik.errors.subrogation_waiver)
                                }
                                errorText={
                                  formik.touched.subrogation_waiver &&
                                  formik.errors.subrogation_waiver
                                }
                              />
                            </Grid>
                          </>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            formik.values.property_in_dealer_custody !== "" &&
            !formik.dirty &&
            propStep8DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepEightForm;
